<template>
  <div class="uk-section-small bgFooter">
    <div class="uk-text-left uk-position-relative">
      <div class="my-container-flex">
        <div class="footer-information-text ">
          <div class="text-footer ">
            <h5 class="uk-text-justify">
              Esta es una colaboración del Consejo Nacional de Competitividad,
              el Observatorio Nacional de la Logística y Transporte de la RD y
              el BID. El objetivo es contribuir al desarrollo e incremento del
              desempeño y la competitividad del transporte y la Logística de carga
              en la República  Dominicana.
            </h5>
          </div>
          <div class="icons">
            <h4>
              <strong>
                Síganos en Social Media
              </strong>
            </h4>
            <div>
              <font-awesome-icon
                class="redIcon"
                :icon="{ prefix: 'fab', iconName: 'facebook' }"
              />
              <font-awesome-icon
                class="redIcon"
                :icon="{ prefix: 'fab', iconName: 'twitter' }"
              />
              <font-awesome-icon
                class="redIcon"
                :icon="{ prefix: 'fab', iconName: 'instagram-square' }"
              />
            </div>
          </div>
        </div>

        <div class="footer-information-adress">
          <div class="footer-information-adress-item">
            <a
              href="https://www.ces.org.do/index.php/contact-us"
              class="uk-link-reset"
            >
              <h4 class="adress">
                <font-awesome-icon
                  class="icon-adress"
                  icon="map-marker-alt"
                />
                <strong>
                  Dirección
                </strong>
              </h4>
              <p class="items-contact-footer">Ave. Abraham Lincoln #295.
                Edificio CARIBALICO. 1er piso. Santo Domingo, República Dominicana</p></a>
          </div>

          <div class="footer-information-adress-item call-email">
            <div class="call-us">
              <h4 class="contactFooter">
                <font-awesome-icon
                  class="icon-adress"
                  icon="phone"
                /> <strong>Llámenos</strong>
              </h4>
              <p class="items-contact-footer">
                <span> +1(809) 567 9271 </span>
              </p>
            </div>

            <div class="email">
              <h4 class="contactFooter">
                <font-awesome-icon
                  class="icon-adress"
                  icon="envelope"
                /> <strong>Email</strong>
              </h4>
              <p class="items-contact-footer">
                onltrd@intec.edu.do
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>

* {
  color: #fff;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;

}

.footer-information-adress {
  width: 40%;
  display: flex;
  margin-left: 55px ;
}
.footer-information-adress-item{
  width: 45%;
  margin: 0px 10px;
}

.my-container-flex{
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;

}
.items-contact-footer{
  margin: 0px;
  padding: 0px;

}
.contactFooter{
  margin:  5px 0px;
  padding: 0px;
}

.adress{
  margin: 5px 0px;
  padding: 0px;
}
.footer-information-text {
  width: 55%;
  text-align: center;
  padding: 5px;
}
.text-footer h5{
  margin: 0px;
}
.icons{
  width: 90%;
  margin: auto;
  display: flex;

}
.icon-adress{
  font-size: 14px;
}
.text-footer {
   width: 90%;
   margin: auto;
}
h6 {
  margin:  0px;
  font-size: 10.5px;
  padding: 5px;
  text-align: end;
}
.bgFooter{
  background-color: #002c3f;
  height: auto;
  padding: 0px 0px;
  margin-top: 25px;

}
.redIcon {
  margin: 3px 0px 0px  15px;
  font-size: 20px;
}

@media screen and (max-width: 1178px){
  .footer-information-text {
     width: 100%;
    text-align: center;
}

.footer-information-adress {
  width: 90%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  margin: auto;
}
}
@media screen and (max-width: 660px){

  .footer-information-adress-item{
  width: 100%;
  margin: 0px 10px;
}

.footer-information-text{
  display: none;
}

.call-email{
  display: flex;
  justify-content: space-between;
}

}

</style>
